import { Typography, Button } from '@mui/material';
import { formatLocalDate } from '../../../../utils/dateUtils';
import Modal from '../../../Modal/Modal';
import { ModalContentContainer, ActionButtons, StyledTextField } from './EditNotesModal.styles';

const EditNotesModal = ({
  open,
  onClose,
  currentDay,
  noteText,
  onNoteTextChange,
  onSave,
  onDelete,
  hasPrivilegedRole,
  hasExistingNote,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      width={450}
      maxHeight="90vh"
      alignContent="left"
      ariaLabelledBy="edit-notes-modal-title"
      variant="default"
    >
      <ModalContentContainer>
        <Typography variant="h6" mb={2} id="edit-notes-modal-title">
          {currentDay
            ? `Edit ${hasPrivilegedRole ? 'Manager' : 'Employee'} Note for ${formatLocalDate(currentDay)}`
            : 'Add Note'}
        </Typography>
        <StyledTextField
          fullWidth
          multiline
          maxRows={4}
          variant="outlined"
          value={noteText}
          onChange={(e) => onNoteTextChange(e.target.value)}
          placeholder={hasPrivilegedRole ? 'Enter manager note' : 'Enter employee note'}
        />
        <ActionButtons>
          <Button fullWidth variant="primary" onClick={onSave} disabled={!noteText.trim()}>
            Save
          </Button>
          {hasExistingNote ? (
            <Button fullWidth variant="primaryDestructive" onClick={onDelete}>
              Delete
            </Button>
          ) : (
            <Button fullWidth variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          )}
        </ActionButtons>
      </ModalContentContainer>
    </Modal>
  );
};

export default EditNotesModal;
